import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],

});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllSent(cxt) {
        let data = await client.get('message/sent');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllReceived(cxt) {
        let data = await client.get('message/received');
        cxt.commit("SET_ALL", data);
        return data;
    },
    /* async getOne(cxt, id) {
        let data = await client.get('fonction/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    }, */
    async create(cxt, payload) {
        let { data } = await client.post('message', payload);
        cxt.commit("SET_ONE", data);
        return data;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
